// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3y0Cg","filesListContainer":"PosDisputesFiles_filesListContainer__rd4PR","filesButton":"PosDisputesFiles_filesButton__8Gjtr"};